var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 345,
    viewBox: "0 0 266 345",
    fill: "none",
    id: "svg167",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4666_72319)",
    id: "g146",
    transform: "translate(6.4999082,5.4590602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 238.975,273.018 c -1.135,-22.763 -9.574,-13.354 -29.904,-17.713 -4.665,-0.999 -11.621,-0.977 -11.628,-0.991 C 181.75,213.909 224.137,196.033 221.041,128.507 219.657,98.5035 215.912,62.4864 200.397,41.571 182.028,16.8035 152.959,4.02734 122.955,4.02734 95.0632,4.02734 66.2653,16.1044 48.0962,37.8901 30.2054,59.3406 22.7295,90.2572 22.7295,122.8 c 0,87.043 39.8121,94.605 30.1533,126.513 -0.107,0.357 -5.3715,2.811 -8.389,4.523 -13.3611,7.59 -35.14678,-7.02 -29.6112,25.901 1.9903,11.863 21.907,16.429 37.2512,10.843 7.697,-2.803 16.7067,-10.379 16.4499,-9.059 -3.952,20.509 10.1438,28.534 21.4076,28.534 11.2637,0 21.4217,-4.994 19.3817,-28.534 -0.014,-0.129 1.598,0.199 1.598,0.449 0,15.508 5.871,25.945 23.705,25.945 15.972,0 21.785,-10.194 19.453,-26.394 -0.107,-0.756 5.878,23.669 22.363,22.385 8.853,-0.692 21.386,-7.448 18.012,-16.978 -4.109,-11.613 0.642,-0.835 1.07,-0.507 4.345,3.289 10.158,5.379 18.333,5.379 15.623,-0.007 25.667,-6.884 25.068,-18.782 z",
    fill: "#f0bee8",
    stroke: "#000000",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.756,96.8 c 23.683,-4.6011 12.969,-1.3768 34.947,-14.9875",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.5371,80.0273 c 15.4155,11.057 17.955,8.4747 39.3556,15.3442",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 176.349,136.311 c 7.926,0 14.352,-6.426 14.352,-14.353 0,-7.927 -6.426,-14.353 -14.352,-14.353 -7.927,0 -14.353,6.426 -14.353,14.353 0,7.927 6.426,14.353 14.353,14.353 z",
    fill: "#fefefc",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.9913,135.24 c 7.9267,0 14.3526,-6.425 14.3526,-14.352 0,-7.927 -6.4259,-14.353 -14.3526,-14.353 -7.9267,0 -14.3526,6.426 -14.3526,14.353 0,7.927 6.4259,14.352 14.3526,14.352 z",
    fill: "#fefefc",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 159.543,171.563 c -2.168,-7.547 9.58,-12.533 18.647,-13.817 11.128,-1.57 18.526,0.478 19.075,6.463 0.464,5.022 -2.561,13.09 -18.647,14.887 -9.109,1.013 -17.341,-1.483 -19.075,-7.533 z",
    fill: "#f6fbd5",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.9591,164.401 c 1.12,-7.204 11.8416,-8.267 21.3363,-6.791 9.4876,1.477 17.1418,5.4 16.0219,12.598 -1.12,7.205 -12.2554,10.073 -20.8655,8.667 -11.8345,-2.311 -17.6127,-7.269 -16.4927,-14.474 z",
    fill: "#f6fbd5",
    id: "path144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs165"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4666_72319",
    x: 0.43359399,
    y: 0.46093801,
    width: 252.133,
    height: 333.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood148"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix150"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    id: "feOffset152"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    id: "feGaussianBlur154"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    id: "feComposite156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    id: "feColorMatrix158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4666_72319",
    id: "feBlend160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4666_72319",
    result: "shape",
    id: "feBlend162"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienPink);
export default __webpack_public_path__ + "static/media/alien_pink.29214048cf2ba0d68fd6ec2d62baca36.svg";
export { ForwardRef as ReactComponent };